import { pxToRem, responsiveFontSizes } from '../utils/getFontValue';

// ----------------------------------------------------------------------

// Brand Typography per Brand Guidelines - Updated to match exact specifications
// Coluna (headlines) - Condensed Bold, All Caps, 83% leading, -1% tracking
// Leif (secondary/serif) - Regular, Sentence case, 110% leading
// Suisse (functional sans) - Regular, Sentence case, 140% leading

const FONT_HEADLINE = '"Coluna", "Roboto Condensed", Impact, sans-serif'; // Headlines - Condensed Bold
const FONT_PRIMARY = '"Suisse", Inter, sans-serif'; // Body - Functional sans serif

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_HEADLINE,
    fontWeight: 700,
    lineHeight: 0.83, // 83% per brand guidelines
    fontSize: pxToRem(40),
    letterSpacing: '-0.01em', // -1% tracking per brand guidelines
    textTransform: 'uppercase',
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontFamily: FONT_HEADLINE,
    fontWeight: 700,
    lineHeight: 0.83,
    fontSize: pxToRem(32),
    letterSpacing: '-0.01em',
    textTransform: 'uppercase',
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontFamily: FONT_HEADLINE,
    fontWeight: 700,
    lineHeight: 0.83,
    fontSize: pxToRem(24),
    letterSpacing: '-0.01em',
    textTransform: 'uppercase',
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.1, // 110% per brand guidelines
    fontSize: pxToRem(20),
    letterSpacing: 0,
    textTransform: 'none',
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.1,
    fontSize: pxToRem(18),
    letterSpacing: 0,
    textTransform: 'none',
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    lineHeight: 1.1,
    fontSize: pxToRem(17),
    letterSpacing: 0,
    textTransform: 'none',
    ...responsiveFontSizes({ sm: 14, md: 16, lg: 18 }),
  },
  subtitle1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.4, // 140% per brand guidelines
    fontSize: pxToRem(16),
    letterSpacing: 0,
  },
  subtitle2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.4,
    fontSize: pxToRem(14),
    letterSpacing: 0,
  },
  body1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.4, // 140% per brand guidelines
    fontSize: pxToRem(16),
    letterSpacing: 0,
  },
  body2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.4,
    fontSize: pxToRem(14),
    letterSpacing: 0,
  },
  caption: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: 0,
  },
  overline: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
    letterSpacing: '-0.02em', // -2% tracking per brand guidelines (Eyebrow style)
  },
  button: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'uppercase',
    letterSpacing: '-0.01em', // -1% tracking per brand guidelines
  },
} as const;

export default typography;
